// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7207) return "static/chunks/7207-58723f199df25308.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2913":"476f810042dd6c1a","5757":"a072fa0482056d5a","6211":"21cd30445b7c5a6f","7372":"88533bb14c227901","8448":"a333bd9926ec746b","9415":"4c557549816c6cfe"}[chunkId] + ".js";
};